import React from 'react';

import { useIntl } from '../../../../util/reactIntl';

import { LinkedLogo, NamedLink } from '../../../../components';

import IconHamburger from '../icons/IconHamburger';

import css from './TopbarMobile.module.css';

/**
 * Mobile topbar — three slots, all visible at once:
 *
 * - Left: hamburger button that opens the slide-in TopbarMobileMenu (state
 *   is owned by the parent Topbar and toggled via `onMenuOpen`).
 * - Center: brand logo (absolutely centered).
 * - Right: a contextual call-to-action button. Unauthenticated users see
 *   "Logg inn" and are sent to the SignupPage welcome gateway (create
 *   account first; login is one click away from there). Authenticated
 *   users see "+ Legg ut" (post a listing) and are sent to NewListingPage.
 *
 * @param {Object} props
 * @param {boolean} props.isAuthenticated
 * @param {Function} props.onMenuOpen
 * @returns {JSX.Element}
 */
const TopbarMobile = props => {
  const { isAuthenticated, onMenuOpen } = props;
  const intl = useIntl();

  return (
    <header className={css.root}>
      <button
        type="button"
        className={css.menuButton}
        aria-label={intl.formatMessage({ id: 'Topbar.openMenuAriaLabel' })}
        onClick={onMenuOpen}
      >
        <IconHamburger className={css.menuIcon} />
      </button>

      <div className={css.logo}>
        <LinkedLogo
          layout="mobile"
          logoImageClassName={css.logoImage}
          alt={intl.formatMessage({ id: 'Topbar.logoAlt' })}
        />
      </div>

      {isAuthenticated ? (
        <NamedLink className={css.cta} name="NewListingPage">
          {intl.formatMessage({ id: 'Topbar.mobileCtaPostListing' })}
        </NamedLink>
      ) : (
        <NamedLink className={css.cta} name="SignupPage">
          {intl.formatMessage({ id: 'Topbar.mobileCtaLogin' })}
        </NamedLink>
      )}
    </header>
  );
};

export default TopbarMobile;
